module.exports = __webpack_public_path__ + "img/Type_Normal.27bee1be.png";